<template>
  <div>
    <div v-if="activar
      " class="d-flex justify-center always-on-top">
      <v-snackbar v-model="snackbar
        " :color="color
    " dark top   elevation="24" >
        <v-row dense>
          <v-col cols="1">
            <v-icon small>{{
              imagen
            }}</v-icon>
          </v-col>
          <v-col cols="11" class="text-center align-center">
            <span>
              {{
                mensaje
              }}
            </span>
          </v-col>
        </v-row>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations,
} from "vuex";
export default {
  data: () => ({
    name: "mensaje",
    snackbar: true,
  }),

  //  // S = Correcto, E = Error, W = Advertencia
  computed:
  {
    ...mapState(
      "mensajeSis",
      [
        "activar",
        "tipo",
        "mensaje",
        "tiempo",
      ]
    ),

    color() {
      let color =
        "";
      if (
        this
          .tipo ==
        "S"
      ) {
        color =
          "#388e3c";
      } else if (
        this
          .tipo ==
        "W"
      ) {
        color =
          "#ffbc00";
      } else if (
        this
          .tipo ==
        "E"
      ) {
        color =
          "#e53935";
      } else {
        color =
          "#01579b";
      }

      return color;
    },

    imagen() {
      let imagen =
        "";

      if (
        this
          .tipo ==
        "S"
      ) {
        imagen =
          "fas fa-check-circle";
      } else if (
        this
          .tipo ==
        "W"
      ) {
        imagen =
          "fas fa-exclamation-triangle";
      } else if (
        this
          .tipo ==
        "E"
      ) {
        imagen =
          "fas fa-exclamation-circle";
      } else {
        imagen =
          "fas fa-bomb";
      }

      return imagen;
    },
  },

  methods:
  {
    ...mapMutations(
      "mensajeSis",
      [
        "setActivar",
        "setClose",
        "setTiempo",
      ]
    ),
  },
};
</script>

<style scoped>
.always-on-top {
  position: absolute;
  align-content: center;
  justify-content: center;
  z-index: 999999999999999 !important
}

/* .fixed-snackbar {
  position: fixed;
} */
</style>
